export default __webpack_public_path__ + "static/media/Series-8000-8100-MP-Inline-Remote.821bc0a6.png";